<template>
  <div class="product-wrapper">
    <div class="product-header">
      <div class="product-header-img-container">
        <img
          src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/fishelf-header-0.jpg"
          alt=""
        />
        <img
          src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/fishelf-header-1.jpg"
          alt=""
        />
        <img
          src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/fishelf-header-2.jpg"
          alt=""
        />
        <img
          src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/fishelf-header-3.jpg"
          alt=""
        />
        <img
          src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/fishelf-header-4.jpg"
          alt=""
        />
        <img
          src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/fishelf-header-5.jpg"
          alt=""
        />
        <img
          src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/fishelf-header-6.jpg"
          alt=""
        />
        <img
          src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/fishelf-header-7.jpg"
          alt=""
        />
        <img
          src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/fishelf-header-8.jpg"
          alt=""
        />
      </div>
      <div class="product-intro">
        <div class="intro-title">{{ isChinese ? `产品介绍` : 'Product Introduction' }}</div>
        <div class="intro-content">
          {{ isChinese ? '“渔精灵”微信小程序是公司利用AI和卫星技术开发的海钓信息服务小程序，立体监测海洋环境、精准预报海钓钓点，开启海钓AI新时代。' : `The "FishFairy" WeChat mini program is a sea fishing information service mini program developed by the company using AI and satellite technology. It provides three-dimensional monitoring of the marine environment, accurate prediction of sea fishing spots, and opens up a new era of sea fishing AI.` }} 
        </div>
      </div>
    </div>
    <div class="ai">
      <div class="header">{{ isChinese ? 'AI钓点预报' : 'AI Fishing Spot Forecast'}}</div>
      <div class="body">
        <div class="left">
          <img
            src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/ai-basan.png"
            alt=""
          />
        </div>
        <div class="right">
          <span class="introduce"
            >{{ isChinese ? `“渔精灵”微信小程序结合AI和卫星技术对海钓钓点的渔情进行预测，可预测的海域范围涵盖我国的东海、南海和黄渤海，以及印度洋、大西洋和太平洋等海域。` : `The "FishFairy" WeChat mini program combines AI and satellite technology to predict the fishing situation of sea fishing spots, covering the East China Sea, South China Sea, Yellow Sea and Bohai Sea, as well as the Indian Ocean, Atlantic Ocean and Pacific Ocean in China.` }}</span
          >
        </div>
      </div>
    </div>
    <div class="share">
      <div class="header">{{ isChinese ? `分享互动` : `Share And Interact` }}</div>
      <div class="body">
        <div class="left">
          <span class="introduce"
            >{{ isChinese ? `“渔精灵”微信小程序为提供钓友们分享、交流的社交平台，方便钓友们互相分享海钓的收获和乐趣，交流学习海钓的经验和技巧。` : `The "FishFairy" WeChat mini program provides a social platform for fishing enthusiasts to share and communicate, making it convenient for them to share the harvest and fun of sea fishing with each other, and exchange experiences and skills in learning sea fishing.` }}</span
          >
        </div>
        <div class="right">
          <img
            src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/share.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="forecast">
      <div class="header">{{ isChinese ? `天气与潮汐` : `Weather And Tides` }}</div>
      <div class="body">
        <div class="left">
          <img
            src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/weather.png"
            alt=""
          />
          <img
            src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/ocean-tide.png"
            alt=""
          />
        </div>
        <div class="right">
          <span class="introduce"
            >{{  isChinese ? `“渔精灵”微信小程序为钓友们提供海钓点的天气、潮汐等信息预报，方便钓友们提前了解天气和潮汐变化，做好海钓准备。` : `The "FishFairy" WeChat mini program provides fishing enthusiasts with weather, tide and other information forecasts for sea fishing spots, making it convenient for them to understand weather and tide changes in advance and prepare for sea fishing.` }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["isChinese"]),
  },
  created() {},
};
</script>
  
  <style lang="scss" scoped>
.product-wrapper {
  padding-bottom: 200px;
}
.product-header {
  // 父容器设为相对定位，作为绝对定位子元素的基准
  position: relative;
  .product-header-img-container {
    display: flex;
    flex-wrap: wrap;
    img {
      width: calc(100% / 3);
      // width: 100%;
    }
  }

  .product-intro {
    // 绝对定位悬浮于图片之上
    //calc((100% - var(--breakpoint-x)) / 2)
    position: absolute;
    top: 20%;
    left: 10%;
    z-index: 2;
    color: white;

    // 视觉样式增强（参考悬浮设计案例）
    padding: 20px;
    max-width: 400px; // 限制宽度防止溢出

    .intro-title {
      font-size: var(--titleFontSize);
      font-weight: bold;
      font-style: italic;
      margin-bottom: 50px;
    }

    .intro-content {
      font-size: var(--contentFontSize);
    }
  }
}

.ai {
  margin-top: 200px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 calc((100% - var(--breakpoint-x)) / 2);
  min-width: var(--breakpoint-z);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  .header {
    font-size: var(--titleFontSize);
    color: rgb(4, 109, 209);
    margin-bottom: 50px;
    font-style: italic;
  }

  .body {
    display: flex;

    .left {
      width: 50%;

      img {
        width: 100%;
      }
    }
    .right {
      padding-left: 200px;
      font-size: var(--contentFontSize);
      color: rgb(10, 113, 210);
    }
  }
}

.share {
  margin-top: 200px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 calc((100% - var(--breakpoint-x)) / 2);
  min-width: var(--breakpoint-z);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  .header {
    font-size: var(--titleFontSize);
    color: rgb(4, 109, 209);
    margin-bottom: 50px;
    font-style: italic;
  }

  .body {
    display: flex;

    .left {
      padding-right: 200px;
      font-size: var(--contentFontSize);
      color: rgb(10, 113, 210);
    }
    .right {
      width: 50%;
      img {
        width: 100%;
      }
    }
  }
}

.forecast {
  margin-top: 200px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 calc((100% - var(--breakpoint-x)) / 2);
  min-width: var(--breakpoint-z);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  .header {
    font-size: var(--titleFontSize);
    color: rgb(4, 109, 209);
    margin-bottom: 50px;
    font-style: italic;
  }

  .body {
    display: flex;

    .left {
      width: 100%;
      display: flex;
      gap: 10px;

      img {
        width: 45%;
      }
    }
    .right {
      padding-left: 200px;
      font-size: var(--contentFontSize);
      color: rgb(10, 113, 210);
    }
  }
}

@media (max-width: 1300px) {
  // .product-intro {
  //   top: 5%;
  // }
  .ai,
  .share,
  .forecast {
    padding: 0 50px;
    margin-top: 100px;
  }
  .header,
  .intro-title {
    font-size: var(--smallTitleFontSize) !important;
    margin-bottom: 25px;
  }
  .intro-content,
  .feature-intro,
  .market-content,
  .intro-content {
    font-size: var(--smallContentFontSize) !important;
  }
  .left,
  .right {
    font-size: var(--smallContentFontSize) !important;
  }

  .product-intro {
    top: 10% !important;
    // 视觉样式增强（参考悬浮设计案例）
    padding: 15px !important;
    max-width: 300px !important; // 限制宽度防止溢出
    .intro-title {
      margin-bottom: 30px !important;
    }
  }
}

@media (max-width: 768px) {
  .body {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
  .left,
  .right {
    padding-left: 0px !important;
    padding-right: 0px !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    width: 100%;

    img {
      width: 100%;
    }
  }
  .header,
  .left,
  .right,
  .intro-content {
    font-size: var(--miniContentFontSize) !important;
  }
  .product-intro {
    top: 0px !important;
    // 视觉样式增强（参考悬浮设计案例）
    padding: 10px !important;
    max-width: 250px !important; // 限制宽度防止溢出
    .intro-title {
      margin-bottom: 15px !important;
    }
  }
}
</style>